"use client";

import { c as _c } from "react/compiler-runtime";
import { track } from "@opensea/analytics";
import { Link } from "@opensea/next-ui-kit";
import { FlexCenter, TextBody, UnstyledButton } from "@opensea/ui-kit";
import { Help } from "@opensea/ui-kit/icons";
import { useTranslations } from "next-intl";
import { useIntercom } from "@/components/support/IntercomProvider";
import { SUPPORT_URL } from "@/constants/constants";
import { Sound, usePlaySound } from "@/hooks/use-play-sound";
export function PageFooterSupportLink() {
  const $ = _c(16);
  const intercom = useIntercom();
  const t = useTranslations("PageFooterSupportLink");
  const [playSelect] = usePlaySound(Sound.Select);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Help size={14} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== t) {
    t1 = t("support");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <FlexCenter className="gap-1 text-text-secondary">{t0}<TextBody size="xs">{t1}</TextBody></FlexCenter>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const content = t2;
  if (intercom.isEnabled) {
    let t3;
    if ($[5] !== intercom || $[6] !== playSelect) {
      t3 = () => {
        track("Intercom footer click", {
          inApp: true
        });
        intercom.boot();
        intercom.show();
        playSelect();
      };
      $[5] = intercom;
      $[6] = playSelect;
      $[7] = t3;
    } else {
      t3 = $[7];
    }
    let t4;
    if ($[8] !== content || $[9] !== t3) {
      t4 = <UnstyledButton onClick={t3}>{content}</UnstyledButton>;
      $[8] = content;
      $[9] = t3;
      $[10] = t4;
    } else {
      t4 = $[10];
    }
    return t4;
  }
  let t3;
  if ($[11] !== playSelect) {
    t3 = () => {
      track("Intercom footer click", {
        inApp: false
      });
      playSelect();
    };
    $[11] = playSelect;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[13] !== content || $[14] !== t3) {
    t4 = <Link href={SUPPORT_URL} onClick={t3} variant="unstyled">{content}</Link>;
    $[13] = content;
    $[14] = t3;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  return t4;
}